export enum ResolvedReason {
    NA = "N/A",
    Unresolved = "Unresolved",
    ResolvedSpokenDirect = "Spoken with child",
    ResolvedExternal = "External issue has been resolved",
    ResolvedOther = "A third reason",
}
